export default "__VITE_ASSET__dF1y7$L7__"